"use strict";import{IconCode as e}from"../src/elements/IconCode.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-code",e);
//# sourceMappingURL=sp-icon-code.js.map
